import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf6371c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topTow-layer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoveTable = _resolveComponent("MoveTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tableData.length > 0)
      ? (_openBlock(), _createBlock(_component_MoveTable, {
          key: 0,
          style: {"height":"467px","margin":"33px 0 0 0"},
          flex: [1,1,1,1],
          title: _ctx.tableTitle,
          data: _ctx.tableData
        }, null, 8, ["title", "data"]))
      : _createCommentVNode("", true)
  ]))
}